import React, { useEffect } from "react";
import { isFormFieldValid, getFormErrorMessage, BUSINESS_LINE_PATHS, BUSINESS_LINE_COLORS } from "../../../../../helpers/utils";
import CreditCardIcon from "../../../../../assets/images/icons/components/CreditCardIcon";
import QuestionIcon from "assets/images/icons/components/QuestionIcon";

import CalendarIcon from "../../../../../assets/images/icons/components/CalendarIcon";
import { classNames } from "primereact/utils";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Divider } from "@mui/material";
import RadioCardOption from "_shared/RadioCardOption";
import * as utils from "../../../helpers/utils";
import { useDispatch, useSelector } from "react-redux";
import { showErrorMessage } from "redux/actions/commonActions";
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";
import CryptoJS from "crypto-js";
import { useState } from "react";
import HelperImgDialog from "application/visit-visa/components/HelperImgDialog/HelperImgDialog";
import SequenceEx from "assets/images/motor/Vehicle_Registration_Card.png";


const SingleVehicle = (props) => {
  const { formik, canAddMore, addNewVehicle, deleteVehicleItem } = props;
  const vehicles = useSelector((state) => state.motor.vehicles);
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const location = useLocation();
  const { businessLine } = useParams()
  const [displayExample, setDisplayExample] = useState(false);

  // REBRANDING COLORS
  let businessColor = BUSINESS_LINE_COLORS.DEFAULT;
  if(businessLine === BUSINESS_LINE_PATHS.BSF) businessColor = BUSINESS_LINE_COLORS.BSF
  else if(businessLine === BUSINESS_LINE_PATHS.STC) businessColor = BUSINESS_LINE_COLORS.STC
  else if(businessLine === BUSINESS_LINE_PATHS.LUCID) businessColor = BUSINESS_LINE_COLORS.LUCID
  else if(businessLine === BUSINESS_LINE_PATHS.SNB) businessColor = BUSINESS_LINE_COLORS.SNB
  else if(businessLine === BUSINESS_LINE_PATHS.ALNAGHI) businessColor = BUSINESS_LINE_COLORS.ALNAGHI

  const currentLanguage = i18n.language;
  const usages = [
    {
      name: "Commercial",
      value: "x31",
    },
  ];

  useEffect(() => {
    formik.setFieldValue('vehicles[0].number', '');
    formik.setFieldValue('vehicles[0].yom', '');
    formik.setFieldValue('vehicles[0].transferId', '');
  }, []);


  const updateVehicleItemValue = (index, name, value) => {
    const myVehiclesArr = [...formik.values.vehicles];

    const existingVehicles = [...vehicles, ...myVehiclesArr].filter(
      (item) => item.serialNumber === value || item.number === value
    );
    if (existingVehicles.length) {
      dispatch(showErrorMessage("Vehicle already exists"));
      setTimeout(() => {
        dispatch(showErrorMessage(""));
      }, 500);
      return;
    }
    myVehiclesArr[index][name] = value;
    props.updateVehicleArray(myVehiclesArr);
  };

  //  if serial number coming from url params
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const encSerialNumber = params.get("serialNumber");

    if (encSerialNumber) {
      const serialNumber = CryptoJS?.AES.decrypt(encSerialNumber.split(" ")?.join("+"), "")?.toString(CryptoJS.enc.Utf8);
      if (serialNumber) {
        updateVehicleItemValue(0, "number", serialNumber)
        addNewVehicle()
      }
    }
  }, [])


  // Validate The Model Year Make
  // Get the current date
  const currentDate = new Date();

  // Set the maxDate to the current year
  let maxDate = new Date(currentDate.getFullYear(), 5, 1, 0, 0, 0); // Month is 5 for June

  // If the current month is June or later, add one more year to maxDate
  if (currentDate.getMonth() >= 5) {
    maxDate.setFullYear(maxDate.getFullYear() + 1);
  }


  return (
    <React.Fragment>
      {formik?.values?.vehicles?.map((vehicleItem, index) => {
        return (
          <div key={index} className="item">
            <div className="header mb-3">
              <p className="text-xs text-bold">{i18n.t("vehicle-details")}</p>
              {formik?.values?.vehicles?.length > 1 && (
                <Button
                  type="button"
                  label={i18n.t("Motor.Delete")}
                  icon="pi pi-trash"
                  onClick={() => deleteVehicleItem(index)}
                />
              )}
            </div>
            <Divider />
            <div className="d-flex justify-content-between mt-2">
              <RadioCardOption
                label={i18n.t("MotorEn.NewInstance")}
                selectOption={() => updateVehicleItemValue(index, "registrationType", "n")}
                value="n"
                type={"outline"}
                name="registrationType"
                onChange={(e) => updateVehicleItemValue(index, "registrationType", "n")}
                classNames="card-option mb-2"
                isChecked={vehicleItem["registrationType"] === "n"}
              />

              <RadioCardOption
                label={i18n.t("MotorEn.TransferOwnership")}
                type={"outline"}
                selectOption={() => updateVehicleItemValue(index, "registrationType", "t")}
                value="t"
                name="registrationType"
                onChange={(e) => updateVehicleItemValue(index, "registrationType", "t")}
                classNames="card-option mb-2"
                isChecked={vehicleItem["registrationType"] === "t"}
              />
            </div>
            <div>
              <p className="px-1 text-xs m-0 text-main-color">{i18n.t("MotorEn.CardType")}</p>
              <div className="row">
                <RadioCardOption
                  label={i18n.t("MotorEn.RegistrationCard")}
                  small={true}
                  type={"normal"}
                  selectOption={() => updateVehicleItemValue(index, "vehicleType", "registration")}
                  value="registration"
                  name="vehicleType"
                  onChange={(e) => updateVehicleItemValue(index, "vehicleType", "registration")}
                  classNames="col-lg-3 col-6"
                  isChecked={vehicleItem["vehicleType"] === "registration"}
                />
                <RadioCardOption
                  label={i18n.t("MotorEn.CustomCard")}
                  small={true}
                  type={"normal"}
                  selectOption={() => updateVehicleItemValue(index, "vehicleType", "custom")}
                  value="custom"
                  name="vehicleType"
                  onChange={(e) => updateVehicleItemValue(index, "vehicleType", "custom")}
                  classNames="col-lg-3 col-6"
                  isChecked={vehicleItem["vehicleType"] === "custom"}
                />
              </div>
              <div className="row">
                {vehicleItem.vehicleType === "registration" && (
                  <div className="field col">
                    <span className="p-input-icon-left">
                    <CreditCardIcon color={businessColor} />
                      <InputText
                        name="number"
                        keyfilter="int"
                        value={vehicleItem.number}
                        className={classNames({
                          "p-invalid": isFormFieldValid(formik, "number") && !vehicleItem.number,
                          "fm-tawuniya": true,
                        })}
                        onChange={(e) => updateVehicleItemValue(index, "number", e.target.value)}
                        placeholder={i18n.t("MotorEn.RegistrationCard")}
                        onKeyPress={(e) => {
                          e.which === 13 && e.preventDefault();
                        }}
                      />
                      <QuestionIcon
                        onClick={() => setDisplayExample(true)}
                        className="question_mark"
                        color={businessColor}
                      />
                    </span>
                    {!vehicleItem.number && getFormErrorMessage(formik, "number")}
                  </div>
                )}
                {vehicleItem.vehicleType === "custom" && (
                  <React.Fragment>
                    <div className="field col">
                      <span className="p-input-icon-left">
                      <CreditCardIcon color={businessColor} />
                        <InputText
                          name="number"
                          keyfilter="int"
                          value={vehicleItem.number}
                          onChange={(e) => updateVehicleItemValue(index, "number", e.target.value)}
                          className={classNames({
                            "p-invalid": isFormFieldValid(formik, "number") && !vehicleItem.number,
                            "fm-tawuniya": true,
                          })}
                          placeholder={i18n.t("MotorEn.CustomCardNumber")}
                          onKeyPress={(e) => {
                            e.which === 13 && e.preventDefault();
                          }}
                        />
                      </span>
                      {!vehicleItem.number && getFormErrorMessage(formik, "number")}
                    </div>
                    <div className="field col">
                      <span className="p-input-icon-left">
                        <Calendar
                          showIcon
                          icon={<CalendarIcon color={businessColor} />}
                          iconPos={"left"}
                          view="year"
                          dateFormat="yy"
                          maxDate={maxDate}
                          name="yom"
                          value={vehicleItem.yom}
                          className={`${currentLanguage === "ar" && "flex-row-reverse"}`}
                          onChange={(e) => updateVehicleItemValue(index, "yom", e.value)}
                          inputClassName={classNames({
                            "p-invalid": isFormFieldValid(formik, "number") && !vehicleItem.yom,
                            "fm-tawuniya": true,
                          })}
                          readOnlyInput
                          placeholder={i18n.t("MotorEn.YearManufacture")}
                          onKeyPress={(e) => {
                            e.which === 13 && e.preventDefault();
                          }}
                        />
                      </span>
                      {!vehicleItem.yom && getFormErrorMessage(formik, "yom")}
                    </div>
                  </React.Fragment>
                )}

                {utils.isSME() && (
                  <div className="field mt-3">
                    <span className="p-float-label">
                      <Dropdown
                        placeholder={i18n.t("Motor.Usage")}
                        name="usage"
                        value={formik.values.usage}
                        onChange={formik.handleChange}
                        options={usages}
                        optionLabel="name"
                      />
                    </span>
                  </div>
                )}
              </div>

              {vehicleItem.registrationType === "t" && (
                <div className="row mt-3">
                  <div className="field col">
                    <span className="p-input-icon-left">
                    <CreditCardIcon color={businessColor} />
                      <InputText
                        name="transferId"
                        keyfilter="int"
                        value={vehicleItem.transferId}
                        onChange={(e) => updateVehicleItemValue(index, "transferId", e.target.value)}
                        className={classNames({
                          "p-invalid":
                            !vehicleItem.transferId && isFormFieldValid(formik, "transferId"),
                          "fm-tawuniya": true,
                        })}
                        placeholder={i18n.t("MotorEn.VehicleBuyer")}
                        onKeyPress={(e) => {
                          e.which === 13 && e.preventDefault();
                        }}
                      />
                    </span>
                    {!vehicleItem.transferId && getFormErrorMessage(formik, "transferId")}
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      })}

      {canAddMore && (
        <div div className="actions">
          {!!vehicles?.length && (
            <Button
              onClick={
                !!vehicles?.length
                  ? (e) => {
                    e.preventDefault();
                    addNewVehicle();
                  }
                  : props.formik.handleSubmit
              }
              disabled={!vehicles?.length}
              // label=  {!!vehicles?.length? i18n.t("MotorEn.AddAnother") : i18n.t("MotorEn.Add")}
              label={i18n.t("MotorEn.Add")}
              icon="pi pi-plus"
              className="p-button-sm add-vehicle"
              style={{background: businessColor}}
            />
          )}
          {/* <Button onClick={props.formik.handleSubmit} className="save-btn">
      {i18n.t("MotorEn.RetrieveVehicles")}
     </Button> */}
          {!!vehicles?.length && (
            <Button onClick={() => props.setAddAnotherVehicleFlag(false)} className="cancel-btn">
              {i18n.t("Motor.Cancel")}
            </Button>
          )}
        </div>
      )}

      <HelperImgDialog img={SequenceEx} visible={displayExample} setVisible={setDisplayExample} />
    </React.Fragment>
  );
};

export default SingleVehicle;
